import { I as Icon, _ as _taggedTemplateLiteral } from './Icon-1198e736.js';
import { useId, createElement } from 'react';
import uniqueId from 'lodash/uniqueId';
import { svgWithValues } from 'nicollet-react-utilities';
import 'styled-components';

function _templateObject() {
  var data = _taggedTemplateLiteral(["<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#CEAF8C\" d=\"M5.25 14.25l-3 7.5h19.5l-3-7.5z\"/><path fill=\"#BA9874\" d=\"M18.75 14.25L12 18.737V14.25z\"/><path d=\"M12 2.25c3.314 0 6 2.71 6 5.914 0 .874-.133 1.6-.412 2.266l-.122.273c-.19.371-2.012 3.054-5.466 8.047-3.512-5.108-5.335-7.79-5.466-8.047l-.034-.075C6.15 9.88 6 9.125 6 8.164 6 4.96 8.687 2.25 12 2.25zm0 3.375a2.625 2.625 0 100 5.25 2.625 2.625 0 000-5.25z\" fill=\"#C00\"/></g></svg>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var svgData = svgWithValues(_templateObject());
var svgMetadata = {
  "width": 24,
  "height": 24,
  "id": "ToolsMapAvailable",
  "monochrome": false,
  "grayscale": false,
  "fullColor": true,
  "fills": ["#000000", "#ceaf8c", "#ba9874", "#cc0000"],
  "nameComponents": {
    "name": "MapAvailable",
    "category": "Tools",
    "variant": null
  }
};

var IconToolsMapAvailable = function IconToolsMapAvailable(props) {
  var _props$id;

  var finalSVGData = svgData({
    idPrefix: ((_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : typeof useId !== 'undefined') ? "nds-Icon".concat(useId()) : // TODO: after migrating to react@18 remove fallback usage of lodash.uniqueId as it causes hydration issues
    uniqueId('nds-Icon')
  });
  return createElement(Icon, Object.assign({}, props, {
    svgData: finalSVGData,
    svgMetadata: svgMetadata
  }));
};

IconToolsMapAvailable.metadata = svgMetadata;
IconToolsMapAvailable.displayName = 'IconToolsMapAvailable';

export { IconToolsMapAvailable };
